<template>
  <!--点击导入按钮弹出框-->
    <div class="addMarkBox" custom-class="el-dialog--center">
      <el-dialog
        @close="closeDialogFile"
        title="导入"
        :visible.sync="daoruMark"
        :close-on-click-modal="false"
        width="40%"
        center
      >
        <div style="margin: 15px auto" class="el-dialog--center">
          <input
            type="file"
            ref="file"
            accept=".xls, .csv, .xlsx"
            @change="getFile($event)"
          />
        </div>
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button @click="closeDialogFile">取消</el-button>
          <el-button type="primary" @click="daoruQueding()" :disabled="isDisable1">确定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import { importDailyCustomers } from '@/api/wms-stock'

export default {
  name: 'daoru',
  data () {
    return {
      isDisable1: false,
      file: []
    }
  },
  props: {
    daoruMark: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialogFile () {
      this.$refs.file.value = ''
      this.$emit('update:daoruMark', false)
    },
    // 导入-确定
    daoruQueding (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        }
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      let name = extname(this.file.name)
      if (name == false) {
        this.$alert('文件为空,请选择文件进行导入', '系统提示')
      } else if (name != 'xlsx' && name != 'csv' && name != 'xls') {
        // xls,.csv
        this.$alert('请选择正确的文件格式', '系统提示')
      } else {
        let formData = new FormData()
        // formData=[]
        formData.append('file', this.file)
        // formData.append("planId", this.id);
        this.isDisable1 = true
        importDailyCustomers(formData)
          .then((res) => {
            console.log(res)
            // -1 提示错误信息， 0 成功， 1显示导出异常
            // this.daoruMark = false
            this.isDisable1 = false
            this.$message({
              message: res,
              type: 'success'
            })
            this.$parent.chaxun()
            this.$emit('update:daoruMark', false)
          })
          .catch((err) => {
            console.log(err)
            // if (err.code == -1) {
            this.$message({
              message: err.data == null ? err.message : err.data,
              type: 'error'
            })
            // } else if (err.code == 1) {
            //   this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            //   })
            //     .then(() => {
            //       const loading = this.$loading({
            //         lock: true,
            //         text: '正在导出异常信息...'
            //       })
            //       let form = {}
            //       exportExcel(
            //         this.global.wmsStockName + '/packag/exportPackagRecordExc',
            //         form,
            //         '打包记录异常表'
            //       )
            //       setTimeout(() => {
            //         this.$message({
            //           type: 'success',
            //           message: '异常信息导出成功!'
            //         })
            //         loading.close()
            //         this.getPackagRecordListS()

            //         // this.daoruMark = false
            //       }, 3000)
            //     })
            //     .catch(() => {
            //       this.$message({
            //         type: 'info',
            //         message: '已取消导出'
            //       })
            //     })
            // }
            this.isDisable1 = false
          })
      }
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    }
  }
}
</script>

<style>

</style>
